import React from "react";
import "./Page.css";
import "components/Tiles/Tiles.css";
import PageLoad from "components/PageLoad/PageLoad";
import Welcome from "components/Welcome/Welcome";
import useTemplate from "hooks/useTemplate";
import ServError from "components/ServError/ServError";
import { t } from "i18next";
import { useAccountContext } from "providers/AccountProvider";

export default function Page(props) {
	const { accountObj } = useAccountContext();
	const { account, disconnect, isAdmin, isSup } = accountObj;
	const { template, getAppFunction } = useTemplate();

	const { isMenuOpen, setIsMenuOpen } = props;

	if (!account.Role || !account.Rights)
		return <PageLoad color={template?.primaryColor()} text={<Welcome />} />;

	if (
		props.curPlatform &&
		props.platform &&
		props.curPlatform !== props.platform &&
		!isAdmin()
	)
		return (
			<ServError
				title={t("Desktop.ERROR") + " 401"}
				text={t("Desktop.UNAUTHORIZED")}
			/>
		);
	return (
		<div className={"page-cont " + props.name + "-page-cont"}>
			{props.component && (
				<props.component
					role={account.Role}
					rights={account.Rights}
					platform={props.curPlatform}
					account={account}
					pages={props.items}
					isAdmin={isAdmin()}
					isSup={isSup}
					title={
						props.adminTitle && props.curPlatform === "admin"
							? props.adminTitle
							: props.title
					}
					theme={props.theme}
					baseUrl={props.url}
					curPage={props.curPage}
					template={template}
					getAppFunction={getAppFunction}
					isMenuOpen={isMenuOpen}
					setIsMenuOpen={setIsMenuOpen}
					setLangCode={props.setLangCode}
					{...props.childprops}
				/>
			)}
		</div>
	);
}
